import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app';
import 'firebase/auth';
import { firestorePlugin } from 'vuefire';

import Login from '@/views/Login';
import SignUp from '@/views/SignUp';
import RoomsList from '@/views/RoomsList';
import Room from '@/views/Room';
import Game from '@/views/Game';
import PlayGame from '@/views/PlayGame';

import SerieGenerator from '@/views/SerieGenerator';

Vue.use(VueRouter)
Vue.use(firestorePlugin)

const routes = [{
  path: '*',
  redirect: '/login'
}, {
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  name: 'Login',
  component: Login
}, {
  path: '/sign-up',
  name: 'SignUp',
  component: SignUp
}, {
  path: '/rooms-list',
  name: 'rooms-list',
  component: RoomsList,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/room/:roomId',
  name: 'room',
  component: Room,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/room/:roomId/:gameId',
  name: 'game',
  component: Game,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/play/:gameId',
  name: 'play-game',
  component: PlayGame,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/serie-generator',
  name: 'serie-generator',
  component: SerieGenerator,
  meta: {
    requiresAuth: true
  }
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next({ path: '/login', query: { redirect: to.fullPath }});
  else if (!requiresAuth && currentUser) next('rooms-list');
  else next();
});

export default router
